document.addEventListener('DOMContentLoaded', function () {
  var gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  var viewer = gallery.querySelector('[id^="GalleryViewer"]');
  var thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
  if (!viewer || !thumbnails) return;

  var prevBtn = viewer.querySelector('.pdp-arrow--prev');
  var nextBtn = viewer.querySelector('.pdp-arrow--next');
  if (!prevBtn || !nextBtn) return;

  function getThumbnailButtons() {
    return Array.from(thumbnails.querySelectorAll('[data-target] button'));
  }

  function getActiveIndex(buttons) {
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].getAttribute('aria-current') === 'true') return i;
    }
    return 0;
  }

  prevBtn.addEventListener('click', function () {
    var buttons = getThumbnailButtons();
    if (buttons.length < 2) return;
    var current = getActiveIndex(buttons);
    var prev = current === 0 ? buttons.length - 1 : current - 1;
    buttons[prev].click();
  });

  nextBtn.addEventListener('click', function () {
    var buttons = getThumbnailButtons();
    if (buttons.length < 2) return;
    var current = getActiveIndex(buttons);
    var next = current === buttons.length - 1 ? 0 : current + 1;
    buttons[next].click();
  });
});
